<div class="odd-format-setting-container">
  <div class="odd-format-header">{{ 'OddType' | translate }}</div>
  <div class="odd-format-general-input-container" *ngIf="'isOddFormatTypeSelect' | getEnv">
    <div class="odd_format_row">
      {{ 'OddType_2' | translate }}
    </div>
    <div class="odd-format-type-input-container" *ngFor="let format of this._UiHelper.oddsFormatTypeData">
      <label for="odd_format_{{ format.id }}" class="odd_format_row_label">
        {{ format.name }}
        <input
          type="radio"
          [checked]="this._UiHelper.customerSelectedOddFormatTypeId == format.id"
          name="odd_format_method"
          id="odd_format_{{ format.id }}"
          value="{{ format.id }}"
          (change)="selectFormatType($event)" />
      </label>
    </div>
  </div>

  <div class="odd-accept-changes-container">
    <div class="odds-changes-container">
      <label>{{ 'Acceptance_Odd_Change' | translate }}</label>
      <div class="accept-container">
        <label class="accept-changes-label" for="anyOddsChange">{{ 'Any_Odd_Change' | translate }}</label>
        <mat-slide-toggle [(ngModel)]="this._UiHelper.checkboxAcceptOdds" (change)="this._UiHelper.setAcceptOdds($event)" color="primary"></mat-slide-toggle>
      </div>
    </div>
    <!-- <div class="favorite-bet-amounts">
      <label>
        {{ 'Favori_Stake' | translate }}
      </label>
      <div class="favorite-bet-amounts-container">
        <input type="number" (input)="setStakeAmount($event.target.value)" min="2" step="1" [value]="this._DataHelper.default_stake_amount.amount_value" />
        <ng-container *ngIf="!stakeButtonAble; else StakeAmountTemplate">
          <div class="bet-settings-accept-button-container">
            <div class="bet-settings-accept-button disable">
              <image-loader-utils url="check-circle" extraClasses="check-circle-icon"></image-loader-utils>
            </div>
          </div>
        </ng-container>
        <ng-template #StakeAmountTemplate>
          <div class="bet-settings-accept-button-container">
            <div class="bet-settings-accept-button" (click)="saveStakeAmount()">
              <image-loader-utils url="check-circle" extraClasses="check-circle-icon won"></image-loader-utils>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="favorite-bet-amounts">
      <label>{{ 'Favori_Bet' | translate }}</label>
      <div class="favorite-bet-amounts-container">
        <ng-container *ngFor="let item of this._DataHelper.default_amount_arr">
          <input type="number" (input)="setBetAmount($event.target.value, item.amount_id)" min="2" step="1" [value]="item.amount_value" />
        </ng-container>
        <ng-container *ngIf="!betButtonAble; else BetAmountsTemplate">
          <div class="bet-settings-accept-button-container">
            <div class="bet-settings-accept-button disable">
              <image-loader-utils url="check-circle" extraClasses="check-circle-icon"></image-loader-utils>
            </div>
          </div>
        </ng-container>
        <ng-template #BetAmountsTemplate>
          <div class="bet-settings-accept-button-container">
            <div class="bet-settings-accept-button" (click)="saveBetAmounts()">
              <image-loader-utils url="check-circle" extraClasses="check-circle-icon won"></image-loader-utils>
            </div>
          </div>
        </ng-template>
      </div>
    </div> -->
  </div>
</div>
